import CountrySelector from 'Components/Header/CountrySelector';
import { ICultureViewModel, ILinkModel } from 'Types/Litium';

const CountryAndContact = ({
    currentCulture,
    linkList,
}: {
    currentCulture: ICultureViewModel;
    linkList: ILinkModel[];
}) => (
    <div className="hidden gap-3.5 lg:flex">
        <ul className="flex gap-3.5">
            {linkList.map((item, index) => (
                <li key={index} className="lg:self-center">
                    <a
                        href={item.href}
                        className="align-center flex items-center gap-1 font-montserrat text-sm font-normal text-black hover:underline"
                    >
                        {item.text}
                    </a>
                </li>
            ))}
        </ul>
        <CountrySelector currentCulture={currentCulture} />
    </div>
);

export default CountryAndContact;
